var ItemBorderPosition;

(function (ItemBorderPosition) {
  ItemBorderPosition["Left"] = "left";
  ItemBorderPosition["Right"] = "right";
  ItemBorderPosition["Top"] = "top";
  ItemBorderPosition["Bottom"] = "bottom";
})(ItemBorderPosition || (ItemBorderPosition = {}));

var ItemInteractionState;

(function (ItemInteractionState) {
  ItemInteractionState["Default"] = "default";
  ItemInteractionState["Hidden"] = "hidden";
  ItemInteractionState["Selected"] = "selected";
  ItemInteractionState["Disabled"] = "disabled";
})(ItemInteractionState || (ItemInteractionState = {}));

var ItemGroupOrientation;

(function (ItemGroupOrientation) {
  ItemGroupOrientation["Horizontal"] = "horizontal";
  ItemGroupOrientation["Vertical"] = "vertical";
})(ItemGroupOrientation || (ItemGroupOrientation = {}));

export { ItemBorderPosition, ItemGroupOrientation, ItemInteractionState };
